export default __webpack_public_path__ + "static/media/Xb1X8OnQ.7f8c8139.jpeg";